import { gql } from '@apollo/client';

export const GET_RESOURCES_GRID_VIEW = gql`
  query GetResourcesGridView {
    vm {
      configItem(key: "resources-grid-view") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;
